import type {
  PhotoShareResponse,
  PhotoSharesResponse,
  SharedGalleryResponse,
} from '@nargus/shared';
import { download, request } from '../http';

export interface ShareRef {
  organizationId: string;
  shareId: string;
}

export interface CreateShareInput {
  organizationId: string;
  albumId?: string;
  photoIds?: string[];
  expiresInDays?: number;
}

export const shareResource = {
  list: (organizationId: string): Promise<PhotoSharesResponse> =>
    request(`/organizations/${organizationId}/shares`),

  create: ({ organizationId, ...body }: CreateShareInput): Promise<PhotoShareResponse> =>
    request(`/organizations/${organizationId}/shares`, {
      method: 'POST',
      body: JSON.stringify(body),
    }),

  remove: ({ organizationId, shareId }: ShareRef): Promise<void> =>
    request(`/organizations/${organizationId}/shares/${shareId}`, { method: 'DELETE' }),

  gallery: (token: string): Promise<SharedGalleryResponse> => request(`/shares/${token}`),

  photo: (token: string, photoId: string): Promise<Blob> =>
    download(`/shares/${token}/photos/${photoId}`),

  thumbnail: (token: string, photoId: string): Promise<Blob> =>
    download(`/shares/${token}/photos/${photoId}?size=thumb`),
};
